import React from "react";
import { useLocation } from "react-router-dom";
import { PaystackButton } from "react-paystack";
import "./PayPage.css";
const PayPage = () => {
  const location = useLocation();
  const item = location.state;
//3043799550 - polaris bank 
  if (!item) return <h2>No service selected</h2>;

  const publicKey = "YOUR_PAYSTACK_PUBLIC_KEY";
//684c1c89e903a59c99d16aac

  const componentProps = {
    email: "customer@email.com",
    amount: item.price * 100, // 🔥 IMPORTANT
    currency: "NGN",
    metadata: {
      name: item.title,
    },
    publicKey,
    text: "Pay Now",
    onSuccess: (res) => {
      alert("Payment successful: " + res.reference);
    },
    onClose: () => {
      alert("Payment closed");
    },
  };

  return (
  <div className="payment-page">
      <button className="back-btn">
        ← Back
      </button>
    <div className="payment-card">

      <img src={item.image} alt={item.title} />

      <h2>{item.category}</h2>
      <h3>{item.title}</h3>

      <p>{item.readTime}</p>

      <div className="price">
        ${item.price.toLocaleString()}
      </div>

      <PaystackButton {...componentProps} />

    </div>

  </div>
);
};

export default PayPage;